import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Field } from 'react-final-form'

import { useAppContext } from 'app/AppContext'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import SelectButtonInput from 'components/form/input/SelectButtonInput';
import AutocompleteInput from 'components/form/input/AutocompleteInput';
import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput'
import SelectInput from 'components/form/input/SelectInput';
import TextInput from 'components/form/input/TextInput';
import ProdutosEntity from '../../../Produto/components/ProdutoDynamicTable';
import TableOtherProducts from '../TableOtherProducts'
import { PField, useFieldValue } from 'components/form/input/NestedField';
import { fieldHasError, requiredValidator } from 'components/form/input/validator'
import DebugObjComp from 'components/DebugObjComp'

import RodadaEntity from 'entity/Rodada';
import InscricaoEntity from 'entity/Inscricao';
import { useReloadEntityField } from 'components/form';
import Box from '@mui/material/Box';
import ExpandMoreIcon from "@mui/icons-material//ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputAdornment, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import { ContentCopy, KeyboardReturn, OpenInNew } from '@mui/icons-material';
import ImageInput from 'components/form/input/ImageInput';
import useNotification from 'notification';
import LanguageSelector from 'components/LanguageSelector';
import { useTranslation } from 'react-i18next';
import BotaoCriarInscricao from 'entity/Inscricao/functions';
import SeletorMunicipios from 'entity/Municipio/components/SeletorMunicipios';
import RenderQuestoesSecundarias from 'entity/Rodada/components/RodadaForm/Questoes/RenderQuestoesSecundarias';
import ProdutoSelector from 'entity/Produto/components/ProdutoSelector';


function InscricaoFormInter(props) {
    const { t } = props
    const { showSuccess, } = useNotification()
    const { change } = props.form
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const searchRodada = searchParams.get("rodada")


    const { uid, rodada, mesa, tipo, empresa, checkOutros, status } = props.values

    const { useSetTitle } = useAppContext()
    useSetTitle(rodada ? "Inscrição - " + rodada.nome : "Inscrição")

    useReloadEntityField(RodadaEntity, 'rodada', props)

    const [inscritos, setInscritos] = useState([])
    const [open, setOpen] = useState(false)

    const statusOnChange = (value, field) => {
        if (field === "status" && value === "CANCELADO") {
            setOpen(true)
        } else if (field === "statusEvento" && (value === "AUSENTE" || value === "SAIU")) {
            setOpen(true)
        }
    }

    useEffect(() => {
        let observer = null
        if (rodada?.uid) {
            observer = InscricaoEntity.collection
                .where("rodada.uid", "==", rodada.uid)
                .where("status", "==", "INSCRITO")
                .onSnapshot(snap => {
                    let resultInscricoes = []
                    snap.forEach((doc) => {
                        resultInscricoes.push(doc.data())
                    })

                    setInscritos([...resultInscricoes])
                })
        }

        return () => {
            if (observer) observer()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rodada])

    const query = (query) => {
        query = query.where("status", "==", "ATIVO")
        return query;
    }
    const loadRodadas = useCallback(async () => {
        if (rodada) {
            const result = await RodadaEntity.get(rodada.uid)
            let novaRodada = result.data
            if (mesa) {
                let indexOf = novaRodada.mesas.map(m => m.uid).indexOf(mesa.uid)
                if (indexOf !== -1) {
                    change("mesa", novaRodada.mesas[indexOf])
                } else {
                    change("mesa", null)
                }
            }
        }
    }, [rodada, mesa, change])


    const carregarInscricaoAnterior = (inscricao) => {

        let empresa = { ...inscricao.empresa }
        empresa.produtosCompra = []
        empresa.produtosVenda = []
        console.log('carregarInscricaoAnterior', empresa)

        change("empresa", empresa)


    }

    useEffect(() => {
        loadRodadas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid])

    const loadRodadaURL = useCallback(async () => {
        if (searchRodada) {
            const result = await RodadaEntity.get(searchRodada)
            change("rodada", result.data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadRodadaURL()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (status === "CANCELADO") {
            change("statusEvento", "AUSENTE")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])
    let uidRodada = searchRodada || rodada?.uid

    return (
        <>
            {(rodada) &&
                <Button
                    startIcon={<KeyboardReturn />}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                        navigate(`/painel-controle?rodada=${rodada.uid}`)
                    }}
                >
                    {t('Retornar ao painel de controle')}
                </Button>
            }
            {(rodada) &&
                <FormRow>
                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ m: 1 }} variant="h6">
                            {t('LINKS PÚBLICOS')}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <TextField
                                sx={{ m: 1 }}
                                label={t("INSCRIÇÃO PÚBLICA ÂNCORA")}
                                defaultValue={`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=1`}
                                variant="filled"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title={t("IR PARA O LINK")}>
                                                <OpenInNew
                                                    sx={{ cursor: "pointer", ml: 2 }}
                                                    onClick={() => {

                                                        window.open(`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=1&painel=1`, '_blank')

                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title={t("COPIAR")}>
                                                <ContentCopy
                                                    sx={{ cursor: "pointer", ml: 2 }}
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=1`)
                                                        showSuccess(t("Link Copiado"))
                                                    }}
                                                />
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled
                            />
                            <TextField
                                sx={{ m: 1 }}
                                label={t("INSCRIÇÃO PÚBLICA FORNECEDOR")}
                                defaultValue={`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=2`}
                                variant="filled"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title={t("IR PARA O LINK")}>
                                                <OpenInNew
                                                    sx={{ cursor: "pointer", ml: 2 }}
                                                    onClick={() => {
                                                        window.open(`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=2&painel=1`, '_blank')

                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title={t("COPIAR")}>
                                                <ContentCopy
                                                    sx={{ cursor: "pointer", ml: 2 }}
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(`${window.location.origin}/#/public-inscricao?rodada=${uidRodada}&type=2`)
                                                        showSuccess(t("Link Copiado"))
                                                    }}
                                                />
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled
                            />
                        </Box>
                    </Box>
                </FormRow>
            }
            <FormContent sx={{ m: 1 }}>

                <LanguageSelector />

                <Typography variant="h6">{t('CADASTRO DA EMPRESA')}</Typography>
                {/* EMPRESA */}
                {/* Dados Rodada */}
                <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                    <Typography
                        variant="h6"
                        sx={{ color: 'text.secondary' }}
                    >
                        {t('DADOS DA RODADA')}
                    </Typography>
                    <FormRow>
                        <SelectInput
                            sx={{ flex: 0.5 }}
                            name="status"
                            label={t("STATUS")}
                            options={[
                                "INSCRITO",
                                "CANCELADO",
                                "PENDENTE/INSCRICAO"
                            ]}
                            optionsToString={[
                                t("INSCRITO"),
                                t("CANCELADO"),
                                t("PENDENTE/INSCRICAO")
                            ]}
                            tooltip={
                                <div>
                                    <b>{t('INSCRITO')}</b> - {t('Inscrição ok (padrão)')} <br />
                                    <b>{t('CANCELADO')}</b> -  {t('Não vai participar da rodada')}<br />
                                    <b>{t('PENDENTE/INSCRICAO')}</b> - {t('Falta alguma informação para aprovar a inscrição')}
                                </div>
                            }
                            onChange={(event) => {
                                change('status', event.target.value) // atualiza o valor do campo no form
                                statusOnChange(event.target.value, "status") // chama a função personalizada
                            }}
                        />
                        <SelectInput
                            sx={{ flex: 0.5 }}
                            name="statusEvento"
                            label={t("STATUS EVENTO")}
                            options={[
                                "INSCRITO",
                                "PRESENTE",
                                "SAIU",
                                "AUSENTE"
                            ]}
                            optionsToString={[
                                t("INSCRITO"),
                                t("PRESENTE"),
                                t("SAIU"),
                                t("AUSENTE"),
                            ]}
                            tooltip={
                                <div>
                                    <b>{t("INSCRITO")}</b> - {t('Vai participar (padrão)')} <br />
                                    <b>{t("PRESENTE")}</b> -  {t('Está presente')}<br />
                                    <b>{t("SAIU")}</b> -  {t('Estava presente, mas foi embora')}<br />
                                    <b>{t("AUSENTE")}</b> - {t('Participante não apareceu')}
                                </div>
                            }
                            onChange={(event) => {
                                change('statusEvento', event.target.value) // atualiza o valor do campo no form
                                statusOnChange(event.target.value, "statusEvento") // chama a função personalizada
                            }}
                        />

                        <Dialog
                            open={open}
                            keepMounted
                            onClose={() => setOpen(false)}
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle>{t("Toda a agenda do participante será cancelada")}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    {t('Toda a agenda é liberada em casos de participantes com Status Evento SAIU e AUSENTE, bem como em casos de status CANCELADO.')}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpen(false)}>{t('OK')}</Button>
                            </DialogActions>
                        </Dialog>

                        <EntitySearchInput
                            name="rodada"
                            label="RODADA"
                            EntityClass={RodadaEntity}
                            extraQuery={query}
                            disabled
                            required
                        />
                        {tipo === "ÂNCORA" &&
                            <>
                                {/* {mesa &&
                                    <Typography
                                        sx={{ alignSelf: "flex-end" }}
                                    >
                                        MESA {rodada?.mesas.indexOf(mesa) + 1} -
                                    </Typography>
                                } */}
                                <AutocompleteInput
                                    name="mesa"
                                    label="MESA"
                                    disabled={rodada ? false : true}
                                    options={rodada?.mesas || []}
                                    getOptionLabel={(option) => option.name || ""}
                                    isOptionEqualToValue={(option, value) => option.uid === value.uid}
                                    getOptionDisabled={(mesaOption) => {
                                        let mesasAncoras = (inscritos || []).filter(i => i.mesa).map(i => i.mesa)

                                        if (mesasAncoras.find(m => m.uid === mesaOption.uid)) {
                                            return true
                                        }
                                        return false
                                    }}
                                />
                            </>
                        }
                    </FormRow>
                    <FormRow>
                        <SelectButtonInput
                            sx={{ flex: 0.33 }}
                            name="tipo"
                            label={t("TIPO DE INSCRIÇÃO")}
                            options={["ÂNCORA", "FORNECEDOR"]}
                            optionsToString={[t("ÂNCORA"), t("FORNECEDOR")]}
                            required
                        />
                    </FormRow>
                </Box>
                {/* Info. Empresa */}
                <Box sx={{ p: 2, width: "100%" }}>
                    <Typography
                        variant="h6"
                        sx={{ color: 'text.secondary' }}
                    >
                        {t('INFORMAÇÕES DA EMPRESA')}
                    </Typography>
                    <FormRow>

                        <SelectInput
                            sx={{ flex: 1 }}
                            name="empresa.tipoPessoa"
                            label="Tipo de Pessoa"
                            required={rodada && rodada.rodadaInternacional === "SIM" ? false : true}
                        >
                            <MenuItem value={"CNPJ"}>Jurídica</MenuItem>
                            <MenuItem value={"CPF"}>Física</MenuItem>
                        </SelectInput>

                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.cnpj"
                            label={empresa?.tipoPessoa === "CPF" ? "Pessoa Física" : "Pessoa Jurídica"}
                            mask={!empresa?.tipoPessoa || (rodada && rodada.rodadaInternacional === "SIM")
                                ? ""
                                : empresa?.tipoPessoa === "CPF"
                                    ? "000.000.000-00"
                                    : "00.000.000/0000-00"
                            }
                            required={rodada && rodada.rodadaInternacional === "SIM" ? false : true}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onBlur={(value) => {
                                console.log('onBlur', value)

                                InscricaoEntity.buscaInscricoesAntigas(value, rodada?.uid).then((inscricoes) => {
                                    console.log('InscricaoEntity inscricoes', inscricoes)
                                    if (inscricoes && inscricoes.length > 0) {
                                        showSuccess(t("Dados de inscrição em rodada anterior encontrado! Carregando..."))
                                        carregarInscricaoAnterior(inscricoes[0])
                                    }
                                })


                            }}
                        />
                        <TextInput sx={{ flex: 2 }} name="empresa.nomeFantasia" label={t("NOME DA EMPRESA")} required />
                        <TextInput sx={{ flex: 1.8 }} name="empresa.nomeEmpresaCracha" label={t("NOME DA EMPRESA NO CRACHÁ")} required />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.razaoSocial"
                            label={t("RAZÃO SOCIAL")}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.endereco"
                            label={t("ENDEREÇO COMPLETO")}
                        />
                        <SeletorMunicipios sx={{ flex: 1 }} label={t("Município")} rodada={rodada} required />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.descricaoEmpresa"
                            label={t("BREVE DESCRIÇÃO DA EMPRESA (RESUMO DE ATUAÇÃO DE SUA EMPRESA)")}
                            required
                            multiline
                        />
                    </FormRow>
                    {/* </Box>

        <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
            <Typography
                variant="h6"
                sx={{ color: 'text.secondary' }}
            >
                CONTATO
            </Typography> */}
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.telComercial"
                            label={t("TELEFONE COMERCIAL")}
                            placeholder="(XX) XXXXX-XXXX"
                            mask={
                                [
                                    {
                                        mask: '(00) 0000-0000',
                                        startsWith: '(',
                                        maxLength: 14,
                                        placeholderChar: '_',
                                        optional: true
                                    },
                                    {
                                        mask: '(00) 00000-0000',
                                        startsWith: '(',
                                        maxLength: 15,
                                        placeholderChar: '_',
                                        optional: true
                                    }
                                ]
                            }
                            // mask="(00) {0}0000-0000"
                            // mask={empresa.funcionarios.telComercial.length === 15 ? "(00) 00000-0000" : "(00) 0000-0000"}
                            // formatChars={{
                            //   "9": "[0-9]",
                            //   "?": "[0-9]"
                            // }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.celular"
                            label={t("CELULAR")}
                            placeholder="(XX) XXXXX-XXXX"
                            mask={
                                [
                                    {
                                        mask: '(00) 0000-0000',
                                        startsWith: '(',
                                        maxLength: 14,
                                        placeholderChar: '_',
                                        optional: true
                                    },
                                    {
                                        mask: '(00) 00000-0000',
                                        startsWith: '(',
                                        maxLength: 15,
                                        placeholderChar: '_',
                                        optional: true
                                    }
                                ]
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput sx={{ flex: 2 }} name="empresa.email" label={t("EMAIL")} type="email" />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.facebook"
                            label={t("FACEBOOK")}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.instagram"
                            label={t("INSTAGRAM")}
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.linkedin"
                            label={t("LINKEDIN")}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.youtube"
                            label={t("YOUTUBE")}
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.site"
                            label={t("SITE")}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.twitter"
                            label={t("TWITTER")}
                        />
                    </FormRow>
                </Box>

                <Typography variant="h6">{t('PARTICIPANTE')}</Typography>
                {/* PARTICIPANTE */}
                {/* <Box sx={{ p: 2, width: "100%" }}> */}
                <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                    <Typography
                        variant="h6"
                        sx={{ color: 'text.secondary' }}
                    >
                        {t('INFORMAÇÕES DO PARTICIPANTE')}
                    </Typography>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 0.5 }}
                            name="empresa.funcionarios.cpf"
                            label="CPF"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            mask={rodada && rodada.rodadaInternacional === "SIM" ? "" : "000.000.000-00"}
                            required={rodada && rodada.rodadaInternacional === "SIM" ? false : true}
                        />
                        <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.nomeParticipante" label={t("NOME COMPLETO")} required />
                    </FormRow>
                    <FormRow>
                        <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.nomeCracha" label={t("NOME NO CRACHÁ")} />
                    </FormRow>
                    <FormRow>
                        <SelectButtonInput
                            sx={{ flex: 0.33 }}
                            name="empresa.funcionarios.sexo"
                            label="SEXO"
                            options={["FEMININO", "MASCULINO", "OUTRO"]}
                            optionsToString={[t("FEMININO"), t("MASCULINO"), t("OUTRO")]}
                        />
                    </FormRow>
                    {/* </Box>
        <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
            <Typography
                variant="h6"
                sx={{ color: 'text.secondary' }}
            >
                CONTATO
            </Typography> */}
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.funcionarios.email"
                            label={t('Email')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            required
                        />
                        <Button disabled={(!props.values.uid || !props.values?.empresa?.funcionarios?.email)} variant="contained" color="primary" sx={{ flex: 0.5, ml: 2 }}
                            onClick={() => { InscricaoEntity.sendThankYouEmail(props.values) }}>
                            Enviar email de confirmação
                        </Button>
                    </FormRow>
                    <FormRow>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.funcionarios.telComercial"
                            label={t('TELEFONE COMERCIAL')}
                            placeholder="(XX) XXXXX-XXXX"
                            mask={
                                [
                                    {
                                        mask: '(00) 0000-0000',
                                        startsWith: '(',
                                        maxLength: 14,
                                        placeholderChar: '_',
                                        optional: true
                                    },
                                    {
                                        mask: '(00) 00000-0000',
                                        startsWith: '(',
                                        maxLength: 15,
                                        placeholderChar: '_',
                                        optional: true
                                    }
                                ]
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.funcionarios.celular"
                            label={t("CELULAR")}
                            placeholder="(XX) XXXXX-XXXX"
                            mask={
                                [
                                    {
                                        mask: '(00) 0000-0000',
                                        startsWith: '(',
                                        maxLength: 14,
                                        placeholderChar: '_',
                                        optional: true
                                    },
                                    {
                                        mask: '(00) 00000-0000',
                                        startsWith: '(',
                                        maxLength: 15,
                                        placeholderChar: '_',
                                        optional: true
                                    }
                                ]
                            }
                            required
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormRow>
                </Box>
                <RenderQuestoesSecundarias rodada={rodada} t={t} />

                {rodada &&
                    <>
                        <Typography variant="h6">
                            {t('PRODUTOS/SERVIÇOS')}
                        </Typography>
                        <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
                                {(tipo === "ÂNCORA" && empresa.produtosCompra?.length) || (tipo === "FORNECEDOR" && empresa.produtosVenda?.length)
                                    ? <></>
                                    : (tipo === "ÂNCORA" && props.modified["empresa.produtosCompra"]) || (tipo === "FORNECEDOR" && props.modified["empresa.produtosVenda"]) || props.submitFailed
                                        ? <Typography sx={{ color: '#f00' }}>Requerido</Typography>
                                        : <></>
                                }
                                <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <ProdutoSelector
                                        name="empresa.produtosCompra"
                                        label={t("Produtos/Serviços que eu compro")}
                                        produtosPermitidos={rodada?.produtos}
                                    />

                                </FormRow>
                                <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <ProdutoSelector
                                        name="empresa.produtosVenda"
                                        label={t("Produtos/Serviços que eu vendo")}
                                        produtosPermitidos={rodada?.produtos}
                                    />
                                </FormRow>
                            </Box>
                            <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <Field
                                        name="checkOutros"
                                        component="input"
                                        type="checkbox"
                                        onChange={(event) => {
                                            const { checked } = event.target
                                            props.form.change('checkOutros', checked)
                                            props.form.change('status', checked ? 'PENDENTE/INSCRICAO' : 'INSCRITO')
                                        }}
                                    />
                                    <Typography
                                        sx={{ ml: 1 }}
                                    >
                                        {t('Sugerir Outros Produtos/Serviços')}
                                    </Typography>
                                </div>
                                {checkOutros && <TableOtherProducts fieldName="outrosProdutos" fieldLabel={t("Outros Produtos")} />}
                            </Box>
                        </FormRow>
                        {rodada.permiteFotosInscricao === "SIM" && <FormRow>
                            <ImageInput name={"fotos"} label={'Fotos de Produtos'} maxQt={5} multiple>
                                <FormRow>
                                    <TextInput name="descricao" label="Descrição" multiline rows={4} />
                                </FormRow>
                            </ImageInput>
                        </FormRow>}
                    </>
                }

                {/* TERMO DE CONSENTIMENTO (LGPD) */}
                <Box sx={{ p: 0, maxWidth: "100%" }}>
                    <Accordion expanded sx={{ p: 0 }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography color="text.secondary">{t('TERMO DE CONSENTIMENTO (LGPD – LEI GERAL DE PROTEÇÃO DE DADOS)')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                            <Typography
                                sx={{
                                    p: 0,
                                    textAlign: "justify",
                                }}
                            >
                                {t('INFORMO QUE OS SEUS DADOS PESSOAIS SERÃO UTILIZADOS PARA O CUMPRIMENTO DE OBRIGAÇÕES CONTRATUAIS, LEGAIS E REGULATÓRIAS DO SEBRAE EM RAZÃO DE SUAS ATIVIDADES, PARA A EXECUÇÃO DE SEUS PROGRAMAS E PRESTAÇÃO DE SERVIÇOS, PARA FOMENTAR, DESENVOLVER E MELHORAR SOLUÇÕES PARA EMPREENDEDORES E PEQUENOS NEGÓCIOS, PARA OFERECER PRODUTOS E SERVIÇOS QUE SEJAM DO SEU INTERESSE, PARA REALIZAR PESQUISAS COM OS CLIENTES QUE FORAM ATENDIDOS PELO SEBRAE E PARA REALIZAR A COMUNICAÇÃO OFICIAL PELO SEBRAE OU POR SEUS PRESTADORES DE SERVIÇO, POR TELEFONE, E-MAIL, SMS, WHATSAPP, ETC., BEM COMO AUTORIZO O COMPARTILHAMENTO DOS MEUS DADOS COM ENTIDADES PARCEIRAS DO SEBRAE E COM CONSULTORES CREDENCIADOS PARA AS MESMAS FINALIDADE ANTERIORMENTE ESPECIFICADAS. CASO VOCÊ QUEIRA CONHECER UM POUCO MAIS DE COMO O SEBRAE TRATA OS SEUS DADOS PESSOAIS, VOCÊ PODE ACESSAR O SEU PORTAL EM WWW.SEBRAE.COM.BR/LGPD, LÁ REUNIMOS UM CONJUNTO DE INFORMAÇÕES SOBRE COMO ESTAMOS ATUANDO COM OS DADOS PESSOAIS DE NOSSOS CLIENTES, COM FOCO EM SEGURANÇA E TRANSPARÊNCIA. POLÍTICA DE PRIVACIDADE: HTTPS://MINIO-CPE.SEBRAE.COM.BR/DOCUMENTO/POLITICA-PRIVACIDADE.PDF. AO ASSINAR O ')}
                                {t("ACEITE LGPD,")}
                                {t(' MANIFESTO-ME DE FORMA INFORMADA, LIVRE, EXPRESSA E CONSCIENTE NO SENTIDO DE AUTORIZAR O SISTEMA SEBRAE A REALIZAR O TRATAMENTO DE MEUS DADOS PESSOAIS PARA AS FINALIDADES AQUI ESTABELECIDAS.')}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <PField
                        name={"termo"}
                        validate={requiredValidator}
                    >
                        {(fieldProps) => {
                            const hasError = fieldHasError(fieldProps.meta);
                            return <Box sx={{}}>
                                <Box sx={{ display: "flex", backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                    <Field
                                        name="termo"
                                        component="input"
                                        type="checkbox"
                                        required
                                    />
                                    <Typography sx={{ ml: 1 }}>{t('DECLARO QUE LI E ACEITO OS TERMOS E CONDIÇÕES.')}</Typography>
                                </Box>
                                {hasError && <Typography sx={{ color: '#f00' }}>{fieldProps.meta.error}</Typography>}
                            </Box>

                        }}
                    </PField>
                </Box>
                <DebugObjComp colection={InscricaoEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
                <BotaoCriarInscricao change={change} rodada={rodada} tipo={"FORNECEDOR"} />
            </FormContent>
        </>
    )
}

export default function InscricaoForm() {
    const { t } = useTranslation()
    const afterSave = (v) => {
        console.log('v', v)
    }
    return (
        <DefaultEntityCrud
            EntityClass={InscricaoEntity}
            title={t("Inscrição")}
            routeForm="inscricao"
            backRoute="consulta-inscricao"
            formActions={{ /*novoForm: true,*/ salvarForm: true/*, sairForm: true*/ }}

            t={t}

        >
            {(props) => {
                return <InscricaoFormInter t={t} {...props} />
            }}
        </DefaultEntityCrud>
    )
}